var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLy = function SvgLy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.19 6.783A11.952 11.952 0 0 0 0 12c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043A11.953 11.953 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 5.739 1.19 6.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M1.191 17.217a12 12 0 0 0 10.81 6.782 12 12 0 0 0 10.808-6.782H1.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M1.191 6.783H22.81A12 12 0 0 0 12 0 12 12 0 0 0 1.191 6.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m14.793 9.805.985 1.357 1.594-.517L16.386 12l.984 1.357-1.594-.519-.986 1.356.001-1.677-1.594-.519 1.595-.517V9.805Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12.106 15.39a3.391 3.391 0 1 1 1.613-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.029.408-1.613.408Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLy;